import { AxiosService } from '../../../utils/AxiosService';
import Config from '../../../config';

const getAssignedAdvisorUserProduct = async userId => await AxiosService.get(Config.server.api.schoolApi + `advisor/user/${userId}/product`, {}, true);
const getProducts = async () => await AxiosService.get(Config.server.api.schoolApi + 'product', {}, true);

export default {
    getProducts,
    getAssignedAdvisorUserProduct
}